'use client';
import React, { useEffect } from 'react';

import { Mobile } from '@components/Mobile';
import { logEvent } from '@utils/googleAnalytics';
import cn from './style.module.scss';

export const leadFormId = 'art-house-lead-form';

export default function ArtGetCall(props: any) {
  const { t } = props;
  const [isLeadFormVisible, setIsLeadFormVisible] = React.useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        setIsLeadFormVisible(entries[0].isIntersecting);
      },
      {
        threshold: 0.1, // Trigger when 10% of the element is visible
      }
    );

    const element = document.getElementById(leadFormId);
    if (element) {
      observer.observe(element);
    }
    return () => {
      if (element) observer.unobserve(element);
    };
  }, []);

  return (
    <Mobile>
      <div
        data-notranslate
        className={`${cn.propertyCall} ${isLeadFormVisible ? cn.hidePropertyCall : ''}`}
      >
        <div className={cn.callInner}>
          <p>{t['oneStepCloser']}</p>
          <a
            href="#teaserContact"
            className={cn.callButton}
            id="launch-register-interest-click"
            onClick={() =>
              logEvent({
                event: 'launch-register-interest-click',
                additionalInfo: {
                  link_id: 'launch-register-interest-click',
                  section: 'navigation',
                },
              })
            }
          >
            {t['actionButton']}
          </a>
        </div>
      </div>
    </Mobile>
  );
}
